import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';

@Injectable({
  providedIn: 'root',
})
export class ConciergeHostService {
  private hosts: Map<Environment, string> = new Map([
    [Environment.LOCAL, 'http://localhost:8090'],
    [Environment.TEST, 'https://arm-test.appspot.com'],
    [Environment.DEMO, 'https://arm-demo.appspot.com'],
    [Environment.PROD, 'https://task-manager.biz'],
  ]);

  private env: Environment;

  constructor(private environment: EnvironmentService) {}

  get conciergeHost(): string {
    if (!this.env) {
      this.env = this.environment.getEnvironment();
    }

    return this.hosts.get(this.env);
  }
}
